import {
  KnowledgeAreaCategoryName,
  KNOWLEDGE_AREA_CATEGORY_NAME,
} from 'views/pages/KnowledgeArea/knowledge-area.interface';

const categories = {
  [KNOWLEDGE_AREA_CATEGORY_NAME.TECHNICAL]: 1,
  [KNOWLEDGE_AREA_CATEGORY_NAME.SOFT]: 2,
};

function getKnowledgeAreaCategoryId(categoryName: KnowledgeAreaCategoryName): number {
  return categories[categoryName];
}

export { getKnowledgeAreaCategoryId };
